import { Component } from '@angular/core';

@Component({
  selector: 'app-grip-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './grip-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class GripIconComponent {}
